module.exports = __webpack_public_path__ + "img/BPalintonon64_ua.17c550c6.webp";